"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AwsMap = void 0;
const react_1 = __importStar(require("react"));
/**
 * Load the CSP bundle of maplibre-gl to avoid CSP issues.
 * See: https://maplibre.org/maplibre-gl-js/docs/#csp-directives
 */
const amazon_location_utilities_auth_helper_1 = require("@aws/amazon-location-utilities-auth-helper");
const maplibre_gl_csp_js_1 = __importDefault(require("maplibre-gl/dist/maplibre-gl-csp.js"));
const styles_1 = require("./styles");
const utils_1 = require("../lib/utils");
const useOffsetLocations_1 = require("./hooks/useOffsetLocations");
function AwsMap({ isStaticMap = false, locations: originalLocations = [], mapEventsToRegister = {}, 
// eslint-disable-next-line @typescript-eslint/no-empty-function
getMarkers = () => { }, onMarkerClick, awsMapConfig: { apiKey, mapName, region, identityPoolId }, defaultMarkerIcon, showFullscreenControl = true, showMultipleMarkersForSameLocation = false, enableAdvancedMarkers = false }) {
    const mapContainerRef = (0, react_1.useRef)(null);
    const mapInitializedRef = (0, react_1.useRef)(false);
    const mapRef = (0, react_1.useRef)(null);
    const markersRef = (0, react_1.useRef)([]);
    const [isLoaded, setIsLoaded] = (0, react_1.useState)(false);
    const locations = (0, useOffsetLocations_1.useOffsetLocations)(originalLocations, showMultipleMarkersForSameLocation);
    (0, react_1.useEffect)(() => {
        const initializeMap = () => __awaiter(this, void 0, void 0, function* () {
            if (mapInitializedRef.current === true) {
                return;
            }
            mapInitializedRef.current = true;
            let styleUrl = `https://maps.geo.${region}.amazonaws.com/maps/v0/maps/${mapName}/style-descriptor`;
            if (apiKey) {
                styleUrl += `?apiKey=${apiKey}`;
            }
            // don't double init map
            if (!mapRef.current) {
                let mapOptions = {
                    container: mapContainerRef.current ? mapContainerRef.current : '',
                    style: styleUrl,
                    maxZoom: 16
                };
                if (identityPoolId) {
                    const authHelper = yield (0, amazon_location_utilities_auth_helper_1.withIdentityPoolId)(identityPoolId);
                    mapOptions = Object.assign(Object.assign({}, mapOptions), authHelper.getMapAuthenticationOptions());
                }
                /**
                 * Set the worker URL for maplibre-gl to avoid CSP issues.
                 * See: https://maplibre.org/maplibre-gl-js/docs/#csp-directives
                 *
                 * Only set the worker URL if it hasn't been set already.
                 */
                if (!maplibre_gl_csp_js_1.default.getWorkerUrl()) {
                    maplibre_gl_csp_js_1.default.setWorkerUrl('/maplibre-gl-csp-worker.js');
                }
                // init map
                mapRef.current = new maplibre_gl_csp_js_1.default.Map(mapOptions);
                if (locations.length > 0) {
                    mapRef.current.fitBounds(locations.reduce((acc, { coordinates }) => {
                        if (coordinates) {
                            return acc.extend(coordinates);
                        }
                        return acc;
                    }, new maplibre_gl_csp_js_1.default.LngLatBounds()), {
                        // prevents animation as map fits to bounds
                        duration: 0,
                        padding: 100
                    });
                }
                if (!isStaticMap) {
                    // add map controls for zooming
                    mapRef.current.addControl(new maplibre_gl_csp_js_1.default.NavigationControl({ showCompass: false }), 'bottom-right');
                    // add fullscreen control only if showFullscreenControl is true
                    if (showFullscreenControl) {
                        mapRef.current.addControl(new maplibre_gl_csp_js_1.default.FullscreenControl(), 'bottom-right');
                    }
                    // register map events and listeners
                    Object.entries(mapEventsToRegister).forEach(([event, cb]) => {
                        if (mapRef.current) {
                            mapRef.current.on(event, (e) => {
                                cb(e, mapContainerRef);
                            });
                        }
                    });
                }
                // handle loading for dynamic & static maps
                // no load event fires when `interactive: false` option is used
                // instead, disabling all handlers after loading is complete
                mapRef.current.on('load', (_e) => {
                    var _a, _b, _c, _d, _f, _g, _h, _j;
                    if (isStaticMap) {
                        (_a = mapRef.current) === null || _a === void 0 ? void 0 : _a.boxZoom.disable();
                        (_b = mapRef.current) === null || _b === void 0 ? void 0 : _b.doubleClickZoom.disable();
                        (_c = mapRef.current) === null || _c === void 0 ? void 0 : _c.dragPan.disable();
                        (_d = mapRef.current) === null || _d === void 0 ? void 0 : _d.dragRotate.disable();
                        (_f = mapRef.current) === null || _f === void 0 ? void 0 : _f.keyboard.disable();
                        (_g = mapRef.current) === null || _g === void 0 ? void 0 : _g.scrollZoom.disable();
                        (_h = mapRef.current) === null || _h === void 0 ? void 0 : _h.touchZoomRotate.disable();
                        (_j = mapRef.current) === null || _j === void 0 ? void 0 : _j.touchPitch.disable();
                    }
                    setIsLoaded(true);
                });
                markersRef.current = (0, utils_1.addMarkers)({
                    locations,
                    awsMapInstance: mapRef.current,
                    isStaticMap,
                    onMarkerClick,
                    defaultMarkerIcon,
                    enableAdvancedMarkers
                });
                getMarkers(markersRef.current);
            }
        });
        initializeMap();
    }, [
        locations,
        isStaticMap,
        mapEventsToRegister,
        apiKey,
        mapName,
        region,
        identityPoolId,
        getMarkers,
        onMarkerClick,
        defaultMarkerIcon,
        showFullscreenControl,
        enableAdvancedMarkers
    ]);
    (0, react_1.useEffect)(() => {
        if (mapRef.current) {
            (0, utils_1.removeMarkers)(markersRef.current);
            markersRef.current = (0, utils_1.addMarkers)({
                locations,
                awsMapInstance: mapRef.current,
                isStaticMap,
                onMarkerClick,
                defaultMarkerIcon,
                enableAdvancedMarkers
            });
            getMarkers(markersRef.current);
        }
    }, [
        locations,
        isStaticMap,
        getMarkers,
        defaultMarkerIcon,
        onMarkerClick,
        enableAdvancedMarkers
    ]);
    return (react_1.default.createElement(styles_1.ComponentContainer, { "data-testid": "AwsMap" },
        !isLoaded ? react_1.default.createElement(styles_1.Loading, null) : null,
        react_1.default.createElement(styles_1.MapContainer, { isLoaded: isLoaded, ref: mapContainerRef })));
}
exports.AwsMap = AwsMap;
//# sourceMappingURL=index.js.map